import { render, staticRenderFns } from "./BotonMontoTotalConceptos2.vue?vue&type=template&id=396e3c7c"
import script from "./BotonMontoTotalConceptos2.vue?vue&type=script&lang=js"
export * from "./BotonMontoTotalConceptos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports